import { Component, OnInit } from '@angular/core';

import { StateMenu } from '~/core/constants/sport-display';
import { CompanyService } from '~/core/services/company.service';
import { RedirectService } from '~/core/services/redirect.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-redirect',
  template: '',
})
export class RedirectComponent implements OnInit {
  constructor(private readonly redirectService: RedirectService,
              private readonly router: Router,
              private route: ActivatedRoute,) {}

  ngOnInit(): void {
    const currentUrl = this.router.url;
    if (currentUrl.includes('home/')) {
      let newUrl = '';
      let queryString = '';
      if (this.route.children[0]?.snapshot?.data?.isHome) {
        newUrl = currentUrl.split('/').filter((path) => path !== 'home' && path !== 'events-area').join('/');
      } else {
        newUrl = currentUrl.split('/').filter((path) => path !== 'home' && path !== 'events-area').join('/');
        [newUrl, queryString] = newUrl.split('?');
      }

      const queryParams = this.parseQueryString(queryString);

      this.router.navigate([newUrl], { queryParams });
    } else {
      const company = CompanyService.currentCompany;
      const state = StateMenu[company.menu?.main?.start] ? StateMenu[company.menu?.main?.start] : StateMenu.PRE_MATCH;
      this.redirectService.openMatchType(state);
    }
  }

  private parseQueryString(queryString: string = ''): Record<string, string> {
    return queryString
      .split('&')
      .filter(Boolean)
      .reduce((acc, param) => {
        const [key, value = ''] = param.split('=');
        if (key) acc[decodeURIComponent(key)] = decodeURIComponent(value);
        return acc;
      }, {} as Record<string, string>);
  }
}
